import { SearchIcon, UserIcon, FacilityIcon } from './icons'

export enum CareTabs {
  ALL = 'all',
  PROVIDER = 'provider',
  FACILITY = 'facility'
}

export type Coords = {
  lat: number
  lng: number
}

export type Specialty = {
  name: string
  type: 'facility' | 'provider'
  value?: string
}

export const commonSpecialties: Specialty[] = [
  {
    name: 'Urgent Care',
    type: 'facility',
    value: 'Urgent Care Clinic'
  },
  {
    name: 'Hospital',
    type: 'facility'
  },
  {
    name: 'Family Medicine',
    type: 'provider'
  },
  {
    name: 'OB-GYN',
    type: 'provider',
    value: 'Obstetrics and Gynecology'
  },
  {
    name: 'Behavioral Health',
    type: 'provider',
    value: 'Behavioral Analyst'
  }
]

export const tabs = [
  {
    label: 'All',
    Icon: SearchIcon
  },
  {
    label: 'Providers',
    Icon: UserIcon
  },
  {
    label: 'Facilities',
    Icon: FacilityIcon
  }
]

export const treatments = [
  'Sinus Infection',
  'Anxiety',
  'Urinary tract infection',
  'Cold & Flu',
  'Depression',
  'Prescription refill',
  'Rash',
  'Yeast infection',
  'Covid-19 concerns',
  'Hypertension'
]
